import styled from 'styled-components';
import { DatePicker } from 'antd';
import { useState } from 'react';
import { Moment } from 'moment';

import { EmployeeGrowthPayload } from 'types';
import { DatePickerIcon } from 'assets/icons';

const StyledWrapperYear = styled.div`
  width: 110px;
  .ant-picker {
    border-radius: 6px;
    border: 1px solid var(--cl_neutral300);
  }
`;

interface EmployeeGrowthFiltersProps {
  loading?: boolean;
  initialValues?: any;
  onSubmit?: (payload: any) => void;
}

export default function PayrollCostByDesignationFilters({
  initialValues,
  onSubmit,
}: EmployeeGrowthFiltersProps) {
  const [monthYear, setMonthYear] = useState<Moment | null>(initialValues?.monthYear || null);

  return (
    <StyledWrapperYear>
      <DatePicker
        picker="month"
        value={monthYear}
        allowClear={false}
        suffixIcon={<DatePickerIcon />}
        onChange={(value) => {
          setMonthYear(value);
          onSubmit?.({ monthYear: value });
        }}
      />
    </StyledWrapperYear>
  );
}
